// @core/api/endpoints/team/get_team_ui_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTeamUISettingsResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get team UI settings
 * Retrieves team u i settings by the specified identifier.
 */
export async function GetTeamUISettings(
  team_id: string,
  options?: RequestOptions
): Promise<GetTeamUISettingsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/settings/ui`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<GetTeamUISettingsResponse>(requestPath, { ...requestOptions });
}
